import React from 'react'
import { useParams } from 'react-router'

import { Text, useBreakpoints } from '@procsea/design-system'

import { CURRENT_MEMBERSHIP_ID_QUERY_PARAM } from 'src/constants/constants'
import { LocaleParams, Membership } from 'src/types'
import { getMembershipName } from 'src/utils'

import {
  StyledAnchor,
  StyledFlex,
  StyledIcon,
  StyledMenuEntry,
} from './MembershipContextMenuItem.styles'

interface MembershipContextMenuItemProps {
  membership: Membership
}

const MembershipContextMenuItem = ({ membership }: MembershipContextMenuItemProps) => {
  const { locale } = useParams<LocaleParams>()
  const { isDesktop } = useBreakpoints()

  const currentMembershipName = getMembershipName(membership)

  return (
    <StyledMenuEntry
      config={{ disableActiveState: true, disableHoverState: true }}
      data-e2e="menu-entry-membership"
      label={
        <StyledFlex fluid>
          <StyledAnchor
            strech
            data-e2e="menu-entry-open-membership"
            href={`/${locale}/?${CURRENT_MEMBERSHIP_ID_QUERY_PARAM}=${membership.id}`}
            rel="noreferrer noopener"
          >
            <Text size={isDesktop ? 'xsmall' : 'small'} variant="black">
              {currentMembershipName}
            </Text>
          </StyledAnchor>
          <StyledAnchor
            data-e2e="menu-entry-open-membership-in-new-tab"
            href={`/${locale}/?${CURRENT_MEMBERSHIP_ID_QUERY_PARAM}=${membership.id}`}
            rel="noreferrer noopener"
            target="_blank"
          >
            <StyledIcon name="up-right-from-square" faStyle="fas" variant="neutral" size="sm" />
          </StyledAnchor>
        </StyledFlex>
      }
    />
  )
}

export default MembershipContextMenuItem
